import { render } from "./WizardsOne.vue?vue&type=template&id=ae9651ac"
import script from "./WizardsOne.vue?vue&type=script&lang=js"
export * from "./WizardsOne.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__